export const cyberpunkTitleSlug = 'cyberpunk-2077' as const;

/** Catalog title id for Cyberpunk 2077 — matches the heatmap API `title_id`. */
export const cyberpunkTitleId = '43046' as const;
